import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import {
  kConnectorDataKeys,
  kConnectorOptionalKeys,
  kKeyToLabelAndDefaultText,
  kPasswordMaskingKeys
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { appcstr } from "@coreapp/utils/appcstr";

const BuildInputOptions = () => {
  const requiredKeys = kConnectorDataKeys["Signify"];
  const optionalKeys = kConnectorOptionalKeys["Signify"];

  const buildOption = (key, optional = false) => {
    const lookupKey = key === "token" ? "apiKey" : key;
    const label = appcstr(kKeyToLabelAndDefaultText[lookupKey][0]);
    const placeholder =
      key === "subdomain"
        ? "https://own.signifyhr.co.za/I/api/v7"
        : appcstr(kKeyToLabelAndDefaultText[lookupKey][1]);

    return {
      dataKey: key,
      label,
      placeholder,
      passwordMask: kPasswordMaskingKeys.includes(key.toLowerCase()),
      optional
    };
  };

  return [
    ...requiredKeys.map(key => buildOption(key)),
    ...optionalKeys.map(key => buildOption(key, true))
  ];
};

export const SignifySetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      doInputLookup={false}
      inputOptions={BuildInputOptions()}
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    />
  );
};
